import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import type { ButtonProps } from '@mui/material/Button';

import { MessageList } from '../MessageList';

import type { AccessGate } from './types/access-gate.type';

interface Props extends ButtonProps {
  readonly gate: AccessGate;
}

// A button closed when the user may not do it: greyed out, the tooltip giving the reasons (a
// disabled button gets no pointer events, hence the span).
export const GatedButton = ({
  gate,
  disabled,
  ...buttonProps
}: Readonly<Props>) => (
  <Tooltip
    title={gate.isAllowed ? '' : <MessageList messages={gate.reasons} />}
  >
    <span>
      <Button
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...buttonProps}
        disabled={Boolean(disabled) || !gate.isAllowed}
      />
    </span>
  </Tooltip>
);
